import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setGlCodeHistoryLogsLoading
    , getGlCodeHistoryLogs
    , setGlCodeHistoryPageSize
    , resetGlCodeHistory
    , setGlCodeHistoryColSearchStr
} from '../../../../constants/model-reducers/external/finance/glcode-details/gl-code-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const glCodeHistoryActions = {
    getGlCodeHistoryLogs: (GlCodeID, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().glCodeHistory.HistoryTable;
        var formData = {
            GlCodeID: GlCodeID,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setGlCodeHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/finance/getGlCodeHistoryLogs', formData);

        dispatch({
            type: getGlCodeHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeGlCodeHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setGlCodeHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extracGlCodeHistoryLogs: (GlCodeID) => async (dispatch, state) => {
        const { Headers } = state().glCodeHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');        
        const filename = `ATEM ${dealName} GL Code History – ${formattedTimeZoneDate}`;

        var formData = {
            GlCodeID: GlCodeID,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/finance/getExtractGlcode', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setGlCodeHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().glCodeHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setGlCodeHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetGlCodeHistory: () => (dispatch, state) => {
        dispatch({
            type: resetGlCodeHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setGlCodeHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getGlCodeHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setGlCodeHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setGlCodeHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetGlCodeHistory:
            return initialState;
        default:
            return state;
    }
}